import {
    GET_BENEF_CONFIRMED_ACTION,
    GET_BENEF_FAILED_ACTION,
    LOADING_TOGGLE_ACTION,
    GET_ASSUR_BENEF_CONFIRMED_ACTION,
    GET_ASSUR_BENEF_FAILED_ACTION,
    GET_SOUSCRPTS_CONFIRMED_ACTION,
    GET_SOUSCRIPTS_FAILED_ACTION,
    GET_GARANTIES_CONFIRMED_ACTION,
    GET_GARANTIES_FAILED_ACTION,
    GET_ACTES_CONFIRMED_ACTION,
    GET_ACTES_FAILED_ACTION,
    SEARCH_CONTRAT_CONFIRMED_ACTION,
    SEARCH_CONTRAT_FAILED_ACTION,
    GET_BENEF_DATA_CONFIRMED_ACTION,
    GET_BENEF_DATA_FAILED_ACTION,
    GET_ALL_BENEF_CONFIRMED_ACTION,
    GET_ALL_BENEF_FAILED_ACTION,
    GET_ASS_PRINC_CONFIRMED_ACTION,
    GET_ASS_PRINC_FAILED_ACTION,
    GET_CONTRATS_CONFIRMED_ACTION,
    GET_CONTRATS_FAILED_ACTION,
    GET_ALL_SOUSCRPTS_CONFIRMED_ACTION,
    GET_ALL_SOUSCRIPTS_FAILED_ACTION,
    GET_ALL_ASS_PRINC_CONFIRMED_ACTION,
    GET_ALL_ASS_PRINC_FAILED_ACTION,
    MAP_ACTE_PROD_GARAN_CONFIRMED_ACTION,
    MAP_ACTE_PROD_GARAN__FAILED_ACTION,
    GET_BENEF_HISTO_CONFIRMED_ACTION,
    GET_BENEF_HISTO_FAILED_ACTION,
    GET_CONTRATS_HISTO_CONFIRMED_ACTION,
    GET_CONTRATS_HISTO_FAILED_ACTION,
    GET_SOUSCRPTS_HISTO_CONFIRMED_ACTION,
    GET_SOUSCRIPTS_HISTO_FAILED_ACTION,
    GET_COLLEGE_PER_CONTRACT_CONFIRMED_ACTION,
    GET_FAMILLE_PER_COLLEGE_CONFIRMED_ACTION,
    GET_CONTRACT_PER_CLIENT_CONFIRMED_ACTION,
    GET_REQUEST_AVENANT_CONFIRMED_ACTION,
    GET_SYNCHRONISATION_ACTION,
    GET_SYNCHRONISATION_LIST_ACTION,
    GET_SYNCHRONISATION_DETAIL_ACTION,
    GET_DETAIL_CONTRACT_ACTION,
    GET_DIFFERENCE_ORASS_ACTION,
    GET_MISSING_DATA_SYNCHRO_ACTION,
    GET_TRACKING_POLICE_SYNCHRO_ACTION,
    SET_POLICY_NUMBER,
    FETCH_BENEFICIARIES_REQUEST,
    FETCH_BENEFICIARIES_SUCCESS,
    FETCH_BENEFICIARIES_FAILURE,
    SYNC_BENEFICIARIES_REQUEST,
    SYNC_BENEFICIARIES_SUCCESS,
    SYNC_BENEFICIARIES_FAILURE,
    CLEAR_ERROR,
    CLEAR_NOTIFICATION,
    SEARCH_ASSURES_CONFIRMED_ACTION 
} from '../actions/ContratActions';

const initialState = {
    beneficiaires: [],
    assureBenefs: [],
    souscripteurs: [],
    beneficiaire: {},
    garanties: [],
    actes: [],
    searchedContrats: [],
    allSouscripteurs: [],
    allContrats: [],
    allAssuresPrincipaux: [],
    allBeneficiaires: [],
    assuresPrincipaux: [],
    contratsHisto: [],
    beneficiairesHisto: [],
    souscripteursHisto: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
    contratPerClient: [],
    collegePerContrat: [],
    famillePerCollege: [],
    incorporationRequests: [],
    retraitRequests: [],
    suspensionRequests: [],
    annulationRequests: [],
    renouvellementRequests: [],
    changementCollegeRequests: [],
    dataMonitoring: [],
    dataSynchroList: [],
    dataSynchroDetail: {},
    detailContract: {},
    policyNumber: '',
    beneficiaries: [],
    assureSearchResults: {},
    loading: false,
    searchPerformed: false,
    syncResult: null,
    error: null
};

export const ContratReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BENEF_CONFIRMED_ACTION:
            return {
                ...state,
                beneficiaires: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };
        case GET_BENEF_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_ASSUR_BENEF_CONFIRMED_ACTION:
            return {
                ...state,
                assureBenefs: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };
        case GET_ASSUR_BENEF_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_SOUSCRPTS_CONFIRMED_ACTION:
            return {
                ...state,
                souscripteurs: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };
        case GET_SOUSCRIPTS_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_GARANTIES_CONFIRMED_ACTION:
            return {
                ...state,
                garanties: action.payload,
                errorMessage: '',
                successMessage: 'Garanties listing Successfully Completed',
                showLoading: false,
            };
        case GET_GARANTIES_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_ACTES_CONFIRMED_ACTION:
            return {
                ...state,
                actes: action.payload,
                errorMessage: '',
                successMessage: 'Actes listing Successfully Completed',
                showLoading: false,
            };
        case GET_ACTES_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case SEARCH_CONTRAT_CONFIRMED_ACTION:
            return {
                ...state,
                searchedContrats: action.payload,
                errorMessage: '',
                successMessage: 'Contrats search Successfully Completed',
                showLoading: false,
            };
        case SEARCH_CONTRAT_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_BENEF_DATA_CONFIRMED_ACTION:
            return {
                ...state,
                beneficiaire: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };
        case GET_BENEF_DATA_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_ALL_BENEF_CONFIRMED_ACTION:
            return {
                ...state,
                allBeneficiaires: action.payload,
                errorMessage: '',
                successMessage: 'Benefs listing Successfully Completed',
                showLoading: false,
            };
        case GET_ALL_BENEF_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_ALL_SOUSCRPTS_CONFIRMED_ACTION:
            return {
                ...state,
                allSouscripteurs: action.payload,
                errorMessage: '',
                successMessage: 'Souscript listing Successfully Completed',
                showLoading: false,
            };
        case GET_ALL_SOUSCRIPTS_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_ALL_ASS_PRINC_CONFIRMED_ACTION:
            return {
                ...state,
                allAssuresPrincipaux: action.payload,
                errorMessage: '',
                successMessage: 'AssPrinc listing Successfully Completed',
                showLoading: false,
            };
        case GET_ALL_ASS_PRINC_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_ASS_PRINC_CONFIRMED_ACTION:
            return {
                ...state,
                assuresPrincipaux: action.payload,
                errorMessage: '',
                successMessage: 'assure principaux listing Successfully Completed',
                showLoading: false,
            };
        case GET_ASS_PRINC_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_CONTRATS_CONFIRMED_ACTION:
            return {
                ...state,
                allContrats: action.payload,
                errorMessage: '',
                successMessage: 'Contrats listing Successfully Completed',
                showLoading: false,
            };
        case GET_CONTRATS_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case MAP_ACTE_PROD_GARAN_CONFIRMED_ACTION:
            return {
                ...state,
                errorMessage: '',
                actes: state.actes.map(act => {
                    if(act.id === action.payload.id) {
                        act = action.payload;
                    }
                    return act;
                }),
                successMessage: 'mapping Successfully Completed',
                showLoading: false,
            };
        case MAP_ACTE_PROD_GARAN__FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_BENEF_HISTO_CONFIRMED_ACTION:
            return {
                ...state,
                beneficiairesHisto: action.payload,
                errorMessage: '',
                successMessage: 'Benef histo listing Successfully Completed',
                showLoading: false,
            };
        case GET_BENEF_HISTO_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_CONTRATS_HISTO_CONFIRMED_ACTION:
            return {
                ...state,
                contratsHisto: action.payload,
                errorMessage: '',
                successMessage: 'Contrat histo listing Successfully Completed',
                showLoading: false,
            };
        case GET_CONTRATS_HISTO_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_SOUSCRPTS_HISTO_CONFIRMED_ACTION:
            return {
                ...state,
                souscripteursHisto: action.payload,
                errorMessage: '',
                successMessage: 'Souscripteurs histo listing Successfully Completed',
                showLoading: false,
            };
        case GET_SOUSCRIPTS_HISTO_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_CONTRACT_PER_CLIENT_CONFIRMED_ACTION:
            return {
                ...state,
                contratPerClient: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_FAMILLE_PER_COLLEGE_CONFIRMED_ACTION:
            return {
                ...state,
                famillePerCollege: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_COLLEGE_PER_CONTRACT_CONFIRMED_ACTION:
            return {
                ...state,
                collegePerContrat: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case GET_REQUEST_AVENANT_CONFIRMED_ACTION:
            return {
                ...state,
                incorporationRequests: action.payload.typeData === 'incorporation' ? action.payload.data : [],
                retraitRequests: action.payload.typeData === 'retrait' ? action.payload.data : [],
                suspensionRequests: action.payload.typeData === 'suspension' ? action.payload.data : [],
                annulationRequests: action.payload.typeData === 'annulation' ? action.payload.data : [],
                renouvellementRequests: action.payload.typeData === 'renouvellement' ? action.payload.data : [],
                changementCollegeRequests: action.payload.typeData === 'changementCollege' ? action.payload.data : [],
                successMessage: '',
                showLoading: false,
            };
        case GET_SYNCHRONISATION_ACTION:{
            return {
                ...state,
                dataMonitoring: action.payload,
                errorMessage: 'Oups!!!',
                successMessage: 'OK',
                showLoading: false,
            };
        };
        case GET_SYNCHRONISATION_LIST_ACTION:{
            return {
                ...state,
                dataSynchroList: action.payload,
                errorMessage: 'Oups!!!',
                successMessage: 'OK',
                showLoading: false,
            };
        };   
        case GET_SYNCHRONISATION_DETAIL_ACTION:{
            return {
                ...state,
                dataSynchroDetail: action.payload,
                errorMessage: 'Oups!!!',
                successMessage: 'OK',
                showLoading: false,
            };
        };   
        case GET_DETAIL_CONTRACT_ACTION:{
            return {
                ...state,
                detailContract: action.payload,
                errorMessage: 'Oups!!!',
                successMessage: 'OK',
                showLoading: false,
            };
        };  
        case GET_DIFFERENCE_ORASS_ACTION:{
            return {
                ...state,
                differenceOrass: action.payload,
                errorMessage: 'Oups!!!',
                successMessage: 'OK',
                showLoading: false,
            };
        };   
        case GET_MISSING_DATA_SYNCHRO_ACTION:{
            return {
                ...state,
                missingData: action.payload,
                errorMessage: 'Oups!!!',
                successMessage: 'OK',
                showLoading: false,
            };
        };  
        case GET_TRACKING_POLICE_SYNCHRO_ACTION:{
            return {
                ...state,
                dataMonitoring: action.payload,
                errorMessage: 'Oups!!!',
                successMessage: 'OK',
                showLoading: false,
            };
        };  
        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                showLoading: true,
            };
            case SET_POLICY_NUMBER:
                return {
                  ...state,
                  policyNumber: action.payload
                };
                
              case FETCH_BENEFICIARIES_REQUEST:
                return {
                  ...state,
                  showLoading: true,
                  errorMessage: null
                };
                
              case FETCH_BENEFICIARIES_SUCCESS:
                console.log(action.payload)
                return {
                  ...state,
                  showLoading: false,
                  beneficiaries: action.payload,
                  searchPerformed: true,
                  errorMessage: null
                };
                
              case FETCH_BENEFICIARIES_FAILURE:
                return {
                  ...state,
                  showLoading: false,
                  beneficiaries: [],
                  errorMessage: action.payload
                };
                
              case SYNC_BENEFICIARIES_REQUEST:
                return {
                  ...state,
                  showLoading: true,
                  errorMessage: null,
                  syncResult: null
                };
                
              case SYNC_BENEFICIARIES_SUCCESS:
                return {
                  ...state,
                  showLoading: false,
                  syncResult: action.payload,
                  errorMessage: null
                };
                
              case SYNC_BENEFICIARIES_FAILURE:
                return {
                  ...state,
                  showLoading: false,
                  errorMessage: action.payload,
                  syncResult: null
                };
                
              case CLEAR_ERROR:
                return {
                  ...state,
                  errorMessage: null
                };
                
              case CLEAR_NOTIFICATION:
                return {
                  ...state,
                  syncResult: null
                };
            case SEARCH_ASSURES_CONFIRMED_ACTION:
                return {
                  ...state,
                  showLoading: false,
                  successMessage: 'Assure search Successfully Completed',
                  errorMessage: '',
                  assureSearchResults: action.payload
                }
        default:
          return state;
    };
};